// id.<root> root — the shared SSO / account app. Unlike id-online's RequireAuth
// (which bounces anonymous users straight into B2C), the identity surface itself
// is the front door: anonymous → Landing (sign in / 2FA / create); authenticated
// → the account hub + its sub-routes (2FA devices, dev/mfa demo). Auth state
// comes from the BFF (`/api/auth/me`), cached via TanStack Query.

import { useQuery } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { authClient } from "./lib/auth";
import { Account } from "./routes/Account";
import { Devices } from "./routes/Devices";
import { DevMfa } from "./routes/DevMfa";
import { Landing } from "./routes/Landing";

export function App() {
  const me = useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => authClient.me(),
  });

  if (me.isLoading) {
    return (
      <header className="hub-page-header">
        <p>Loading…</p>
      </header>
    );
  }

  const session = me.data ?? null;
  if (!session) return <Landing />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Account session={session} />} />
        <Route path="/devices" element={<Devices session={session} />} />
        <Route path="/dev/mfa" element={<DevMfa session={session} />} />
      </Routes>
    </BrowserRouter>
  );
}
